const setAttestations = (state, payload) => {
  state.attestations = payload;
};
const setAttestationLang = (state, lang) => {
  state.attestationLang = lang;
  localStorage.setItem("attestation_lang", lang);
};
export default {
  setAttestations,
  setAttestationLang,
};
